import { render, staticRenderFns } from "./UserLevel.vue?vue&type=template&id=c32a443a"
import script from "./UserLevel.vue?vue&type=script&lang=js"
export * from "./UserLevel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports